import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import { Color, getColor, getColorLight } from '../ColoredChip';

const SIZE = 20;

const Bubble = styled('span')<{
  sizeFactor: number;
  fgColor: string;
  bgColor: string;
}>((p) => ({
  height: SIZE,
  width: SIZE + p.sizeFactor * 10,
  display: 'flex',
  padding: `0 6px`,
  flexWrap: 'wrap',
  fontSize: '0.75rem',
  alignItems: 'center',
  boxSizing: 'border-box',
  borderRadius: SIZE / 2,
  flexDirection: 'row',
  justifyContent: 'center',
  background: p.bgColor,
  color: p.fgColor,
  lineHeight: 1
}));

export const CountBubble = ({
  value,
  color = 'gray',
  showZero = false,
  mode = 'normal'
}: {
  value: number;
  color?: Color;
  showZero?: boolean;
  mode?: 'light' | 'normal';
}) => {
  const theme = useTheme();
  if (!showZero && !value) {
    return null;
  }
  const [fgColor, bgColor] =
    mode === 'normal' ? getColor(theme, color) : getColorLight(theme, color);
  return (
    <Bubble
      sizeFactor={`${value}`.length - 1}
      fgColor={fgColor}
      bgColor={bgColor}
    >
      {value}
    </Bubble>
  );
};
